function sendPageEvent() {
  // If the analytics was not loaded, we simply return
  if (window.digitalData === undefined) return;

  const siteSection = document
    .querySelector("meta[name='vrt-analytics-name']")
    .getAttribute("content");

  const pageName = `tools${window.location.pathname}`;
  const dnow = Date.now();
  const data = {
    event: {
      schema: "iglu:be.vrt/page_impression/jsonschema/1-1-0",
      data: {
        timestamp: dnow,
      },
    },
    context: [
      {
        schema: "iglu:be.vrt/context_page/jsonschema/1-2-1",
        data: {
          pagename: pageName,
          touchpointbrand: "vrt",
          contentbrand: "edubox",
          pageurl: window.location.href,
          pagetitle: `${siteSection}: reflector`,
          domain: "www.vrt.be",
          pagepath: pageName,
          pagelanguage: "nl",
          sitesection1: "",
          sitesection2: "",
          sitesection3: `${siteSection}`,
          sitesection4: "",
          pageid: pageName,
        },
      },
    ],
  };
  window.digitalData.events.push(data);
}

if (import.meta.env.PROD) {
  document.addEventListener("turbo:load", () => {
    let pageEventInterval = setInterval(() => {
      if (window.digitalData) {
        sendPageEvent();
        clearInterval(pageEventInterval);
      }
    }, 100);
  });
}
